import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 5.48907L4.13266 2.97813V4.40719L6.37754 4.40717L6.34952 3.01085C6.32673 1.87552 7.2118 0.951412 8.29042 0.984337L9.86734 1.09187V4.76837e-07L14 2.51094L9.86734 5.02187V3.08018L8.23572 2.96892L8.26375 4.36524C8.28608 5.47792 7.4351 6.39259 6.37755 6.39259L4.13266 6.39261V8L0 5.48907Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }